import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { RoutingService, UIService } from '@services';
import { AuthStore, DevicesStore, InstallationDetailsStore, RemoteServiceStore } from '@store';

import {
  RemoteServiceOverlayTypeEnum,
  RemoteServiceUrlTypeEnum,
} from '../../installation-overlay.model';

@Component({
  selector: 'app-remote-service-tabs',
  templateUrl: './remote-service-tabs.component.html',
  styleUrls: ['./remote-service-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoteServiceTabsComponent implements OnInit, OnDestroy {
  tabs: {
    type: RemoteServiceOverlayTypeEnum;
    title: string;
    active: boolean;
  }[];

  isMaintainerWithFreeOrBasicOrPlusPackage = false;
  isE3HeatpumpDevice = false;

  @Input() activeOverlay: RemoteServiceOverlayTypeEnum;

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private isDemo = false;

  constructor(
    private routingService: RoutingService,
    private uiService: UIService,
    private remoteServiceStore: RemoteServiceStore,
    private authStore: AuthStore,
    private installationDetailsStore: InstallationDetailsStore,
    private deviceStore: DevicesStore
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.installationDetailsStore.isMaintainerWithFreeOrBasicOrPlusPackage$,
      this.deviceStore.isE3HeatpumpDevice(),
      this.authStore.isDemo$,
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([isMaintainerWithFreeOrBasicOrPlusPackage, isE3HeatpumpDevice, isDemo]) => {
        this.isMaintainerWithFreeOrBasicOrPlusPackage = isMaintainerWithFreeOrBasicOrPlusPackage;
        this.isE3HeatpumpDevice = isE3HeatpumpDevice;
        this.isDemo = isDemo;
        this.setTabs();
      });
  }

  onTabSelect(type: RemoteServiceOverlayTypeEnum): void {
    if (type !== this.activeOverlay) {
      this.remoteServiceStore.tabChanged(type);

      switch (type) {
        case RemoteServiceOverlayTypeEnum.Anomalies: {
          this.routingService.replaceChildPathOnUrl(RemoteServiceUrlTypeEnum.Anomalies);
          break;
        }
        case RemoteServiceOverlayTypeEnum.Diagnosis: {
          this.routingService.replaceChildPathOnUrl(RemoteServiceUrlTypeEnum.Diagnosis);
          break;
        }
        case RemoteServiceOverlayTypeEnum.Features: {
          this.routingService.replaceChildPathOnUrl(RemoteServiceUrlTypeEnum.Features);
          break;
        }
        case RemoteServiceOverlayTypeEnum.Report: {
          this.routingService.replaceChildPathOnUrl(RemoteServiceUrlTypeEnum.Report);
          break;
        }
      }

      this.uiService.activeRemoteServiceOverlay$.next(type);
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private setTabs(): void {
    if (this.isMaintainerWithFreeOrBasicOrPlusPackage && this.isE3HeatpumpDevice) {
      this.tabs = [
        {
          type: RemoteServiceOverlayTypeEnum.Diagnosis,
          title: '+REMOTE_SERVICE.TABS_DIAGNOSIS',
          active: true,
        },
      ];
    } else {
      this.tabs = [
        {
          type: RemoteServiceOverlayTypeEnum.Anomalies,
          title: '+REMOTE_SERVICE.TABS_ANOMALIES',
          active: true,
        },
        {
          type: RemoteServiceOverlayTypeEnum.Diagnosis,
          title: '+REMOTE_SERVICE.TABS_DIAGNOSIS',
          active: true,
        },
        {
          type: RemoteServiceOverlayTypeEnum.Features,
          title: '+REMOTE_SERVICE.TABS_FEATURES',
          active: true,
        },
        {
          type: RemoteServiceOverlayTypeEnum.Report,
          title: '+REMOTE_SERVICE.TABS_REPORT',
          active: !this.isDemo,
        },
      ];
    }
  }
}
